var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMissedCallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FEECEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#missed-call-icon_svg__clip0_1302:13888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.71 22.67A16.971 16.971 0 0018 18c-4.54 0-8.66 1.78-11.71 4.67-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7h-.01zm15.08 1.26c-.6-.48-1.22-.9-1.88-1.27v-1.7c1.05.51 2.03 1.15 2.95 1.9l-1.07 1.07zM13 12.43l4.94 4.94 7.07-7.07-1.41-1.42-5.66 5.66L14.4 11H17V9h-6v6h2v-2.57z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "missed-call-icon_svg__clip0_1302:13888"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6 6)",
    d: "M0 0h24v24H0z"
  })))));
}

export default __webpack_public_path__ + "7333fdb4bcfdd089c3f4794f758116b0.svg";
export { SvgMissedCallIcon as ReactComponent };